module.exports = __webpack_public_path__ + "static/media/article7.60a0ac48.webp";